import type { Map as MapLibreMap, MapMouseEvent } from "maplibre-gl";
import type { MutableRefObject } from "react";
import { POI_LAYER_IDS } from "./mapHelpers";
import type { POI } from "../MapCanvas";

/**
 * Setup POI click and hover handlers for all tier layers
 */
export function setupPoiEvents(
  map: MapLibreMap,
  poisRef: MutableRefObject<POI[]>,
  onPOIClick: ((poi: POI) => void) | undefined,
  onMapClickRef: MutableRefObject<((e: MapMouseEvent) => void) | undefined>
): void {
  const poiLayers = [...POI_LAYER_IDS];

  // POI click handler for all tiers
  if (onPOIClick) {
    poiLayers.forEach((layerId) => {
      if (!map.getLayer(layerId)) return;

      map.on("click", layerId, (e) => {
        if (e.features && e.features[0]) {
          const clickedId = e.features[0].properties?.id;
          const poi = poisRef.current.find((p) => p.id === clickedId);
          if (poi) {
            onPOIClick(poi);
          }
        }
      });

      // Change cursor on POI hover
      map.on("mouseenter", layerId, () => {
        map.getCanvas().style.cursor = "pointer";
      });
      map.on("mouseleave", layerId, () => {
        map.getCanvas().style.cursor = "";
      });
    });
  }

  // General map click handler - always register, check ref at runtime
  map.on("click", (e) => {
    // Check if we clicked on a POI - if so, don't fire map click
    // Query all POI layers that exist
    const existingLayers = poiLayers.filter((id) => map.getLayer(id));
    const features = existingLayers.length > 0
      ? map.queryRenderedFeatures(e.point, { layers: existingLayers })
      : [];
    if (features.length === 0 && onMapClickRef.current) {
      onMapClickRef.current(e);
    }
  });
}
